import {Component, Input, OnInit} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {DadService} from '../../../services/dad.service';
import {formatDate} from '@angular/common';
import {saveAs} from 'file-saver';

@Component({
  selector: 'app-dad-status',
  templateUrl: './dad-status.component.html',
  styleUrls: ['./dad-status.component.scss']
})
export class DadStatusComponent implements OnInit {

  @Input() exchangeNamesList: any[];

  @Input() set companiesItems(value) {
    this.selectedClients = [];
    this.uniqCompanyItems = [];
    value.forEach(companyItem => {
      if (this.uniqCompanyItems.filter(item => item.value === companyItem.value).length === 0) {
        this.uniqCompanyItems.push(companyItem);
        this.selectedClients.push(companyItem.value);
      }
    });
  }

  selectedClients: SelectItem[] = [];
  dateFilterFrom: any;
  dateFilterTo: any;
  selectedExchanges = [];
  uniqCompanyItems = [];

  constructor(private dadService: DadService) {
  }

  ngOnInit() {
    this.initializeDateFilter();
    if (this.exchangeNamesList) {
      this.selectedExchanges = this.exchangeNamesList.map(exchange => exchange.value);
    }
  }

  private initializeDateFilter() {
    this.dateFilterFrom = new Date();
    this.dateFilterFrom.setDate(1);
    this.dateFilterFrom.setMonth(this.dateFilterFrom.getMonth() - 2);
    this.dateFilterTo = new Date();
    this.dateFilterTo.setDate(1);
  }

  exportCSV() {
    this.dadService.getDadListForStatus(
      this.selectedExchanges,
      this.dateFilterFrom,
      this.dateFilterTo,
      this.selectedClients
    ).subscribe(
      res => {
        const fileNamePrefix = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
        let fileNameSuffix = '';
        if (this.selectedExchanges.length === 1) {
          fileNameSuffix += '_DAD_Status_' + this.selectedExchanges[0] + '.csv';
        } else {
          fileNameSuffix += '_DAD_Status.csv';
        }
        this.downLoadFile(res, fileNamePrefix + fileNameSuffix);
      }
    );
  }

  downLoadFile(data: any, fileName: string) {
    const blob = new Blob([data]);
    saveAs(blob, fileName);
  }
}
